'use client'
import {
  Button_default
} from "./chunk-5TLHZ4PW.mjs";
import {
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/Carousel/Carousel.tsx
import { Fragment, useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import WheelGestures from "embla-carousel-wheel-gestures";
import { twMerge } from "tailwind-merge";
import { ChevronIcon } from "@wbk/svg";
import { useRouter } from "@wbk/config";
import { Fragment as Fragment2, jsx, jsxs } from "react/jsx-runtime";
var Carousel = ({
  children,
  rootClassName,
  containerClassName,
  className,
  thumbClassName,
  options,
  autoplay,
  title = null,
  arrows,
  arrowsClassName,
  dots,
  renderDot,
  renderHeader,
  renderFooter,
  thumbs,
  onInit,
  onIndexChanged,
  as
}) => {
  const Component = as || "div";
  const { locale } = useRouter();
  const direction = (locale == null ? void 0 : locale.startsWith("ar")) ? "rtl" : "ltr";
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [snapCount, setSnapCount] = useState(0);
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  const [emblaRef, emblaApi] = useEmblaCarousel(
    __spreadValues({
      align: "start",
      direction,
      slidesToScroll: "auto"
    }, options),
    [
      Autoplay(__spreadValues({
        active: !!autoplay,
        playOnInit: true,
        stopOnInteraction: false,
        stopOnMouseEnter: true
      }, typeof autoplay === "object" ? autoplay : {})),
      WheelGestures()
    ]
  );
  const [emblaThumbsRef] = useEmblaCarousel({
    containScroll: "keepSnaps",
    dragFree: true,
    direction
  });
  const onSelect = useCallback((emblaApi2) => {
    if (!emblaApi2) return;
    setPrevBtnDisabled(!emblaApi2.canScrollPrev());
    setNextBtnDisabled(!emblaApi2.canScrollNext());
    setSnapCount(emblaApi2.scrollSnapList().length);
    setSelectedIndex(emblaApi2.selectedScrollSnap());
    if (onIndexChanged) {
      onIndexChanged(emblaApi2.selectedScrollSnap());
    }
  }, []);
  useEffect(() => {
    if (!emblaApi) return;
    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);
  useEffect(() => {
    if (emblaApi && onInit) {
      onInit(emblaApi);
    }
  }, [emblaApi]);
  const scrollPrev = () => {
    if (emblaApi) emblaApi.scrollPrev();
  };
  const scrollNext = () => {
    if (emblaApi) emblaApi.scrollNext();
  };
  const scrollTo = (index) => {
    if (emblaApi) emblaApi.scrollTo(index);
  };
  const helperProps = {
    selectedIndex,
    scrollPrev,
    scrollNext,
    scrollTo,
    prevBtnDisabled,
    nextBtnDisabled
  };
  const elements = typeof children === "function" ? children(helperProps) : children;
  const dotsList = Array.from({ length: snapCount }, (_, i) => i);
  return /* @__PURE__ */ jsxs(Fragment2, { children: [
    renderHeader && renderHeader(helperProps),
    /* @__PURE__ */ jsxs("div", { className: twMerge("relative", rootClassName), children: [
      (title || arrows === "top") && /* @__PURE__ */ jsxs("div", { className: twMerge("pb-L gap-M flex justify-between", arrowsClassName), children: [
        /* @__PURE__ */ jsx("div", { className: "grow", children: title }),
        (!prevBtnDisabled || !nextBtnDisabled) && arrows && arrows === "top" && /* @__PURE__ */ jsxs("div", { className: "hidden gap-2 md:flex", children: [
          /* @__PURE__ */ jsx(
            Button_default,
            {
              shape: "outlined",
              theme: "action",
              className: "rounded-S flex h-[30px] w-[30px] items-center justify-center border p-0 data-[hide=true]:hidden",
              onClick: scrollPrev,
              disabled: prevBtnDisabled,
              "data-hide": prevBtnDisabled && nextBtnDisabled,
              "aria-label": "Previous",
              children: /* @__PURE__ */ jsx(ChevronIcon, { className: "h-3 w-3 ltr:rotate-180" })
            }
          ),
          /* @__PURE__ */ jsx(
            Button_default,
            {
              shape: "outlined",
              theme: "action",
              className: "rounded-S flex h-[30px] w-[30px] items-center justify-center border p-0 data-[hide=true]:hidden",
              onClick: scrollNext,
              disabled: nextBtnDisabled,
              "data-hide": prevBtnDisabled && nextBtnDisabled,
              "aria-label": "Next",
              children: /* @__PURE__ */ jsx(ChevronIcon, { className: "h-3 w-3 rtl:rotate-180" })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: twMerge("overflow-hidden", className), ref: emblaRef, children: /* @__PURE__ */ jsx(
        Component,
        {
          style: { backfaceVisibility: "hidden" },
          className: twMerge("flex touch-pan-y", containerClassName),
          children: elements
        }
      ) }),
      thumbs && /* @__PURE__ */ jsx("div", { className: thumbClassName, children: /* @__PURE__ */ jsx("div", { className: "overflow-hidden", ref: emblaThumbsRef, children: thumbs({ selectedIndex, scrollTo }) }) }),
      arrows === "middle" && /* @__PURE__ */ jsxs(
        "div",
        {
          className: twMerge(
            "absolute left-1/2 top-1/2 w-full -translate-x-1/2 ltr:[&>button:first-of-type]:left-0 rtl:[&>button:first-of-type]:right-0 ltr:[&>button:last-of-type]:right-0 rtl:[&>button:last-of-type]:left-0",
            arrowsClassName
          ),
          children: [
            /* @__PURE__ */ jsx(
              Button_default,
              {
                className: "bg-body-level-1 absolute top-1/2 z-[1] m-2 flex h-11 w-11 -translate-y-1/2 cursor-pointer touch-manipulation appearance-none items-center justify-center p-0 aria-hidden:hidden",
                type: "button",
                onClick: scrollPrev,
                disabled: prevBtnDisabled,
                "aria-hidden": prevBtnDisabled,
                "aria-label": "Previous",
                children: /* @__PURE__ */ jsx(
                  "svg",
                  {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 32 32",
                    fill: "none",
                    className: "fill-text rtl:rotate-180",
                    children: /* @__PURE__ */ jsx("path", { d: "M20.9426 8.94263C21.4633 8.42194 21.4633 7.57772 20.9426 7.05703C20.4219 6.53633 19.5777 6.53633 19.057 7.05703L11.057 15.057C10.5523 15.5618 10.5346 16.3745 11.017 16.9007L18.3503 24.9007C18.8478 25.4435 19.6913 25.4802 20.2341 24.9826C20.7769 24.485 20.8136 23.6416 20.316 23.0988L13.8453 16.0399L20.9426 8.94263Z" })
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx(
              Button_default,
              {
                className: "bg-body-level-1 absolute top-1/2 z-[1] m-2 flex h-11 w-11 -translate-y-1/2 cursor-pointer touch-manipulation appearance-none items-center justify-center p-0 aria-hidden:hidden",
                type: "button",
                onClick: scrollNext,
                disabled: nextBtnDisabled,
                "aria-hidden": nextBtnDisabled,
                "aria-label": "Next",
                children: /* @__PURE__ */ jsx(
                  "svg",
                  {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 32 32",
                    fill: "none",
                    className: "fill-text rotate-180 rtl:rotate-0",
                    children: /* @__PURE__ */ jsx("path", { d: "M20.9426 8.94263C21.4633 8.42194 21.4633 7.57772 20.9426 7.05703C20.4219 6.53633 19.5777 6.53633 19.057 7.05703L11.057 15.057C10.5523 15.5618 10.5346 16.3745 11.017 16.9007L18.3503 24.9007C18.8478 25.4435 19.6913 25.4802 20.2341 24.9826C20.7769 24.485 20.8136 23.6416 20.316 23.0988L13.8453 16.0399L20.9426 8.94263Z" })
                  }
                )
              }
            )
          ]
        }
      ),
      dots && dotsList.length > 1 && /* @__PURE__ */ jsx("div", { className: "bg-text/10 absolute bottom-5 left-0 right-0 z-[1] mx-auto flex w-fit flex-wrap items-center justify-center rounded-full p-1.5", children: dotsList.map((index) => /* @__PURE__ */ jsx(Fragment, { children: renderDot ? renderDot({ selectedIndex }) : /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            textDecoration: "none"
          },
          className: `m-0 ml-1 mr-1 inline-flex h-[7px] w-[7px] touch-manipulation appearance-none items-center border-0 bg-transparent p-0 transition after:h-[7px] after:w-full after:rounded-full ${index === selectedIndex ? "after:bg-text" : "after:bg-text/40"}`
        }
      ) }, index)) })
    ] }),
    renderFooter && renderFooter(helperProps)
  ] });
};

export {
  Carousel
};
//# sourceMappingURL=chunk-CL4ULIEG.mjs.map